import { defineMessages, FormattedMessage } from 'react-intl';

import * as S from './MyWatchView.style';
const intlPrefix = 'myWatchView';

export const messages = defineMessages({
  keyFeaturesTitle: {
    id: `${intlPrefix}.keyFeaturesTitle`,
    defaultMessage: 'Key features',
  },
  addStrapTitle: {
    id: `${intlPrefix}.addStrapTitle`,
    defaultMessage: 'Add an extra strap',
  },
  technicalDataTitle: {
    id: `${intlPrefix}.technicalDataTitle`,
    defaultMessage: 'Technical data',
  },
  coscCertificate: {
    id: `${intlPrefix}.coscCertificate`,
    defaultMessage: 'COSC Certificate',
  },
  userManual: {
    id: `${intlPrefix}.userManual`,
    defaultMessage: 'User manual',
  },
  referenceNumber: {
    id: `${intlPrefix}.referenceNumber`,
    defaultMessage: 'Reference number',
  },
  validUntil: {
    id: `${intlPrefix}.validUntil`,
    defaultMessage: 'Valid until',
  },
  activated: {
    id: `${intlPrefix}.activated`,
    defaultMessage: 'Activated on',
  },
  serialNumber: {
    id: `${intlPrefix}.serialNumber`,
    defaultMessage: 'Serial number',
  },
  breitlingWarranty: {
    id: `${intlPrefix}.breitlingWarranty`,
    defaultMessage: 'BREITLING WARRANTY',
  },
  limitedEditionCertificate: {
    id: `${intlPrefix}.limitedEditionCertificate`,
    defaultMessage: 'Limited Edition Certificate',
  },
  jewelryCertificate: {
    id: `${intlPrefix}.jewelryCertificate`,
    defaultMessage: 'Jewelry Certificate',
  },
  year140Certifiacte: {
    id: `${intlPrefix}.year140Certifiacte`,
    defaultMessage: '140 Years Certificate',
  },
  customerSupport: {
    id: `${intlPrefix}.customerSupport`,
    defaultMessage: 'customer support',
  },
});

export const Warranty = (
  <FormattedMessage defaultMessage='Warranty' id={`${intlPrefix}.warranty`} />
);

export const WarrantyHint = (
  <FormattedMessage
    defaultMessage='Extend your warranty for another {duration} years'
    id={`${intlPrefix}.warrantyHint`}
  />
);
export const ExtendMyWarranty = (
  <FormattedMessage
    defaultMessage='Extend My Warranty'
    id={`${intlPrefix}.extendMyWarranty`}
  />
);
export const MyWatchNeedsAService = (
  <FormattedMessage
    defaultMessage='My Watch Needs A Service'
    id={`${intlPrefix}.myWatchNeedsAService`}
  />
);
export const BreitlingTrade = (
  <FormattedMessage
    defaultMessage='Edit my watch on breitling trade'
    id={`${intlPrefix}.breitlingTrade`}
  />
);
export const LastEstimate = (
  <FormattedMessage
    defaultMessage='Last estimate date'
    id={`${intlPrefix}.lastEstimate`}
  />
);
export const EstimateMyWatch = (
  <FormattedMessage
    defaultMessage='Estimate My Watch'
    id={`${intlPrefix}.estimateMyWatch`}
  />
);

export const ValidUntil = (
  <FormattedMessage
    defaultMessage='Valid until 12/10/2025'
    id={`${intlPrefix}.validUntilTime`}
  />
);

export const Active = (
  <FormattedMessage defaultMessage='ACTIVE' id={`${intlPrefix}.active`} />
);
export const Inactive = (
  <FormattedMessage defaultMessage='Inactive' id={`${intlPrefix}.inactive`} />
);
export const RemoveFromMyAccount = (
  <FormattedMessage
    defaultMessage='Remove from my account'
    id={`${intlPrefix}.removeFromMyAccount`}
  />
);

export const MyWatchServiceHistory = (
  <FormattedMessage
    defaultMessage='My watch service history'
    id={`${intlPrefix}.myWatchServiceHistory`}
  />
);

export const RegisterMyWatch = (
  <FormattedMessage
    defaultMessage='REGISTER MY WATCH'
    id={`${intlPrefix}.registerMyWatch`}
  />
);

export const ViewItInMyWatches = (
  <FormattedMessage
    defaultMessage='View it in my watches'
    id={`${intlPrefix}.viewItInMyWatches`}
  />
);

export const WatchRegisteredByYourAccount = (
  <FormattedMessage
    defaultMessage='This watch is already registered to your account.'
    id='addWatch.sameAccount'
  />
);

/**
 * Localized error message component for watch registration errors
 * @param callCustomerService - Function to call customer support
 * @param id - The message ID for internationalization
 * @param defaultMessage - The fallback message if translation not found
 */
export const RegisteredError = ({
  callCustomerService,
  defaultMessage = 'Watch registration error. Please contact {customerSupport}.',
  id = `myWatchView.registeredError`,
}: {
  callCustomerService?: () => void;
  defaultMessage?: string;
  id?: string;
}) => (
  <FormattedMessage
    defaultMessage={defaultMessage}
    id={id}
    values={{
      customerSupport: (
        <S.CustomerSupport onClick={() => callCustomerService?.()}>
          <FormattedMessage
            defaultMessage='customer support'
            id={`${intlPrefix}.customerSupport`}
          />
        </S.CustomerSupport>
      ),
    }}
  />
);
